//clients 2.0 script
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

// can not use loop because it breaks styling when using breakpoints
document.addEventListener( 'DOMContentLoaded', function() {
  if(document.querySelector('.clients-2-0__container .splide') !== null) {
    var splide = new Splide( '.clients-2-0__container .splide', {
      type: 'loop',
      drag   : 'free',
      focus: 'center',
      lazyLoad: 'nearby',
      pagination: false,
      arrows: false,
      autoWidth: true,
      // Add AutoScroll as a component with options
      autoScroll: {
          speed: 1,
          pauseOnHover: false,
      },
    });

    // Mount the Splide instance and AutoScroll
    splide.mount({ AutoScroll });

  }
} );
